import { gql } from '@apollo/client'

import {
  cartFragment,
  cartUserErrorFragment,
  cartWarningFragment,
} from '../objects/cart'

export const createCartMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation createCart($cartInput: CartInput) {
    cartCreate(input: $cartInput) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const updateCartBuyerIdentityMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation updateCartBuyerIdentity(
    $buyerIdentity: CartBuyerIdentityInput!
    $cartId: ID!
  ) {
    cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const updateCartAttributesMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation updateCartAttributes($cartId: ID!, $attributes: [AttributeInput!]!) {
    cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const updateCartNoteMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation updateCartNote($cartId: ID!, $note: String!) {
    cartNoteUpdate(cartId: $cartId, note: $note) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const addCartLinesMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation addCartLines($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const updateCartLinesMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation updateCartLines($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const removeCartLinesMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation removeCartLines($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const updateCartDiscountCodesMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation updateCartDiscountCodes($cartId: ID!, $discountCodes: [String!]) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const addCartDeliveryAddressesMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation addCartDeliveryAddresses(
    $addresses: [CartSelectableAddressInput!]!
    $cartId: ID!
  ) {
    cartDeliveryAddressesAdd(addresses: $addresses, cartId: $cartId) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const updateCartDeliveryAddressesMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation updateCartDeliveryAddresses(
    $addresses: [CartSelectableAddressUpdateInput!]!
    $cartId: ID!
  ) {
    cartDeliveryAddressesUpdate(addresses: $addresses, cartId: $cartId) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`

export const removeCartDeliveryAddressesMutation = gql`
  ${cartFragment}
  ${cartUserErrorFragment}
  ${cartWarningFragment}

  mutation removeCartDeliveryAddresses($addressIds: [ID!]!, $cartId: ID!) {
    cartDeliveryAddressesRemove(addressIds: $addressIds, cartId: $cartId) {
      cart {
        ...CartFragment
      }
      userErrors {
        ...CartUserErrorFragment
      }
      warnings {
        ...CartWarningFragment
      }
    }
  }
`
